import { createRelayResource } from '@townsquare/relay-utils';

import TagUpdatesViewQuery, {
	type TagUpdatesViewQuery as TagUpdatesViewQueryType,
} from '../TagUpdatesView/__generated__/TagUpdatesViewQuery.graphql';

export const tagUpdatesResource = createRelayResource<TagUpdatesViewQueryType>({
	getQuery: routerContext => {
		return {
			query: TagUpdatesViewQuery,
			variables: {
				tagUUID: routerContext?.match?.params.id,
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
